import { selectAll } from '../utilities';

function blurEach (e) {
  let els = selectAll('input', e.target);

  els.forEach((el) => {
    el.blur();
  });
};

export default {
  inserted: function (el, binding) {
    if (binding.arg === 'submit') {
      // <form v-blur:submit>
      // Triggers blur for each input in the form
      el.addEventListener('submit', blurEach);
    }
  },

  unbind: function (el, binding) {
    if (binding.arg === 'submit') {
      el.removeEventListener('submit', blurEach);
    }
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/shared/directives/blur.js